export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.ca3e9ba2.jpg";